import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";
import { validateUserRoleIds } from "../GlobalTools";
import PurchaseModuleModal from "../modals/PurchaseModuleModal";

/**
 * Purpose: Element to show menu icons validated for premium services
 * @param {object} props
 * @return {JSX} Icon element
 */
export default function IconPremium(props) {
  const canShowPremiumIcon = validateUserRoleIds([1, 2]);
  const show = !props.showCrown || canShowPremiumIcon;
  const [showPremiumModal, setShowPremiumModal] = useState(false);

  const handleClick = useCallback(() => {
    setShowPremiumModal(true);
  }, []);

  return show ? (
    <>
      <div
        className={props.validation}
        onClick={props.showCrown ? handleClick : null}
      >
        <Image
          src={props.image}
          id={props.id}
          className={props.className}
          style={props.style}
        />
        {props.showCrown && (
          <i className="ms-1 fa-lg fas fa-crown premiumColor position-absolute" />
        )}
        <br />
        <p style={{ fontSize: "1.2300123001230012vh" }}>{props.title}</p>
      </div>
      {showPremiumModal && (
        <PurchaseModuleModal
          showModal={showPremiumModal}
          closeModal={() => setShowPremiumModal(false)}
          name={props.serviceName}
          originView={props.fromView}
        />
      )}
    </>
  ) : null;
}

IconPremium.propTypes = {
  image: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  validation: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  showCrown: PropTypes.bool,
  serviceName: PropTypes.string,
  fromView: PropTypes.string,
};
